<template>
  <div>
    <table class="action-prop-table">
      <tr>
        <th>old level</th>
        <td
          class="text-right"
        >
          {{action.oldLevel | getFormattedNumber}}
        </td>
      </tr>
      <tr>
        <th>new level</th>
        <td
          class="text-right"
        >
          {{action.newLevel | getFormattedNumber}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'UserActionInfoSetPlayerLevel',

  props: {
    action: {
      type: Object,
      required: true,
    }
  },
};
</script>
